import { SeverityLevel } from "@microsoft/applicationinsights-web";
import getAzureApplicationInsights from "../plugins/applicationInsights";
import { Tenant } from "../types/globals";
import resourceApi from "./apis/iam/resourceApi";
import { getCurrentUser } from "./msal";

async function getUserTenants(): Promise<any[]> {
  const user = await getCurrentUser();
  if (!user) {
    return [];
  }

  const tenantResponse = await resourceApi.getUsersTenants();
  return tenantResponse.values;
}

async function validateTenantAccess(tenant: Tenant): Promise<boolean> {
  const userTenants = await getUserTenants();

  return userTenants.some(
    (userTenant) =>
      userTenant.casablancaId.toLowerCase() === tenant.id.toLowerCase()
  );
}

async function getCurrentTenantFromStorage(): Promise<Tenant | null> {
  const currentTenant = localStorage.getItem("currentTenant");
  if (currentTenant && currentTenant !== "") {
    try {
      const parsedTenant: Tenant = JSON.parse(currentTenant);
      parsedTenant.id = parsedTenant.id.toLowerCase();
      return parsedTenant;
    } catch (error) {
      const appInsights = await getAzureApplicationInsights();
      appInsights.trackException({
        exception: error,
        severityLevel: SeverityLevel.Error,
      });
      localStorage.removeItem("currentTenant");
      return null;
    }
  }
  return null;
}

async function getCurrentTenant(): Promise<Tenant | null> {
  const currentTenant = await getCurrentTenantFromStorage();
  if (!currentTenant) {
    return null;
  }

  const hasAccess = await validateTenantAccess(currentTenant);
  if (!hasAccess) {
    localStorage.removeItem("currentTenant");
    return null;
  }

  return currentTenant;
}

async function setCurrentTenant(tenant: Tenant) {
  if (tenant) {
    const currentTenantStr = localStorage.getItem("currentTenant");
    let currentTenant: Tenant | null = null;

    if (currentTenantStr && currentTenantStr !== "") {
      try {
        currentTenant = JSON.parse(currentTenantStr);
        currentTenant.id = currentTenant.id.toLowerCase();
      } catch (error) {
        console.error(
          "Failed to parse current tenant from localStorage:",
          error
        );
        localStorage.removeItem("currentTenant");
      }
    }

    if (
      !currentTenant ||
      currentTenant?.id.toLowerCase() !== tenant.id.toLowerCase()
    ) {
      const hasAccess = await validateTenantAccess(tenant);

      if (hasAccess) {
        localStorage.setItem("currentTenant", JSON.stringify(tenant));
        window.location.href = `/`;
      } else {
        localStorage.removeItem("currentTenant");
        window.location.href = `/iam/resourceselection`;
      }
    }
  }
}

window.setCurrentTenant = setCurrentTenant;
window.getCurrentTenant = getCurrentTenant;

export { getCurrentTenant, getCurrentTenantFromStorage, setCurrentTenant };
